module.exports = __webpack_public_path__ + "img/food_20.218aba01.jpg";